import { render, staticRenderFns } from "./task_detail.vue?vue&type=template&id=0de0a608&scoped=true"
import script from "./task_detail.vue?vue&type=script&lang=js"
export * from "./task_detail.vue?vue&type=script&lang=js"
import style0 from "./task_detail.vue?vue&type=style&index=0&id=0de0a608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de0a608",
  null
  
)

export default component.exports